export enum CategoryFilterOperatorEnum {
    And = "And",
    Or = "Or"
}